import React from 'react';
import { IIconProps } from '../interfaces';
const CpuIcon = (props: IIconProps) => {
  return (

  <svg xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height} viewBox="0 0 22 22" fill="none">
    <path d="M8.65369 0.935429L8.81405 0.93543L8.81405 3.50918H8.65369V0.935429Z" stroke="#1D1D1D" strokeWidth="1.28687"/>
    <path d="M13.2577 0.935429L13.4181 0.93543L13.4181 3.50918H13.2577V0.935429Z" stroke="#1D1D1D" strokeWidth="1.28687"/>
    <path d="M1.11756 12.8409L1.11756 12.6806L2.97354 12.6806V12.8409H1.11756Z" stroke="#1D1D1D" strokeWidth="1.28687"/>
    <path d="M1.08191 8.50402L1.08191 8.34366L2.9379 8.34366V8.50402H1.08191Z" stroke="#1D1D1D" strokeWidth="1.28687"/>
    <path d="M21.0182 12.8409L21.0182 12.6806L19.1866 12.6806V12.8409H21.0182Z" stroke="#1D1D1D" strokeWidth="1.28687"/>
    <path d="M21.0426 8.50402L21.0426 8.34366L19.211 8.34366V8.50402H21.0426Z" stroke="#1D1D1D" strokeWidth="1.28687"/>
    <path d="M8.65369 21.0646L8.81405 21.0646L8.81405 18.4908H8.65369V21.0646Z" stroke="#1D1D1D" strokeWidth="1.28687"/>
    <path d="M13.2582 21.0646L13.4185 21.0646L13.4185 18.4908H13.2582V21.0646Z" stroke="#1D1D1D" strokeWidth="1.28687"/>
    <rect x="3.59229" y="3.4668" width="14.9981" height="14.9981" rx="2.65787" stroke="#1D1D1D" strokeWidth="1.3633"/>
    <mask id="path-10-inside-1_4537_2816" fill="white">
      <rect x="8.59668" y="8.42676" width="5.18685" height="5.3535" rx="0.746464"/>
    </mask>
    <rect x="8.59668" y="8.42676" width="5.18685" height="5.3535" rx="0.746464" stroke="#1D1D1D" strokeWidth="2.63751" mask="url(#path-10-inside-1_4537_2816)"/>
  </svg>
  )
};

export default CpuIcon;